import { Button, Input, Modal, Radio } from "antd";
import React, { Component } from "react";
import searchIcon from "../../assets/images/searchicon.svg";
import networkList from "../../constants/networkList";
import postService from "../../services/httpService";
import { patientSchema, tokenSchema } from "../../schema/token";
import TokenPatientCard from "./TokenPatientCard";
import CustomLoader from "../../components/loader";
import moment from 'moment';

const $ = require("jquery");

class TokenGenerator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tokenFields: [],
      patientFields: [],
      tokensList: [],
      filteredList: [],
      tokenType: "",
      serviceType: "",
      phone: "",
      searchVal: "",
      isLoading: false,
      errors: {},
      modalData: {},
      visible: false,
    };
  }

  getTokensList() {
    const { getTokensForTG } = networkList;
    this.setState({ isLoading: true });

    postService(getTokensForTG, "GET", null)
      .then((res) => this.setState({ tokensList: res.data, isLoading: false }))
      .catch((err) => {
        this.setState({ isLoading: false });
    
      });
  }

  generateToken() {
    const { generateTokenForQueue } = networkList;
    const { tokenType, serviceType, phone } = this.state;
    const payload = {
      phone_number: phone,
      token_type: tokenType.toLowerCase(),
      service: serviceType,
    };
    tokenType && serviceType && phone.length === 10
      ? postService(generateTokenForQueue, "POST", {
          data: payload,
        })
          .then((res) => {
            if (res.status) {
              this.setState({visible: true,
                modalData: res.data[0]})
            
                  this.setState({ errors: {} });
                  // this.onRefresh();
                  // this.props.history.push("/queue/token-generator");
                
             
            } else {
              Modal.error({
                title: "Error!",
                content: res.message
                  ? res.message
                  : "Oops! something went wrong. Please try again.",
              });
            }
          })
          .catch((error) => {
            Modal.error({
              title: "Error Message",
              content: `Something is wrong. Please try again. ${error}`,
            });
          })
      : this.setState({
          errors: {
            tokenType: !tokenType && "Select Token Type",
            serviceType: !serviceType && "Select Service Type",
            phone: !phone
              ? "Enter Phone Number."
              : phone.length !== 10 && "Enter valid number.",
          },
        });
  }

  componentDidMount() {
    let tokenschemaData = $.extend(true, {}, tokenSchema);
    let patientschemaData = $.extend(true, {}, patientSchema);
    this.setState(
      (state) => ({
        tokenFields: tokenschemaData.feilds,
        patientFields: patientschemaData.feilds,
      }),
      () => {
        this.prepareQueue();
      }
    );

    this.getTokensList();
  }

  componentDidUpdate() {
    $(".custom-container").css({
      height:
        $(window).outerHeight() -
        ($("header").outerHeight() + $(".breadCrums").outerHeight()),
      "padding-bottom": "0px",
    });
    $(".b-card").css({
      height: $(".custom-container").outerHeight() - 30,
    });
    $(".b-card-scroll").css({
      height: $(".b-card").outerHeight(),
    });
    $("footer").hide();
  }

  //   componentDidUpdate(prevProps, prevState) {
  //     if (prevState !== this.state) {
  //       let tokenschemaData = $.extend(true, {}, tokenSchema);
  //       let patientschemaData = $.extend(true, {}, patientSchema);
  //       console.log("tokenschema cdu", tokenschemaData);
  //       console.log("patientschema cdu", patientschemaData);
  //       this.setState(
  //         (state) => ({
  //           tokenFields: tokenschemaData.feilds,
  //           patientFields: patientschemaData.feilds,
  //         }),
  //         () => {
  //           this.prepareQueue();
  //         }
  //       );
  //     }
  //   }

  onRefresh() {
    this.setState({ tokenType: "", serviceType: "", phone: "" });
    this.getTokensList();
  }

  prepareQueue() {
    let { tokenFields } = this.state;
    tokenFields.map((element, key) => {
      tokenFields[key]["value"] = null;
      tokenFields[key]["valid"] = false;
    });
    this.setState((state) => ({ tokenFields: tokenFields }));
  }

  onChange(event) {
    let { tokenFields, patientFields } = this.state;
    let errors = [];

  

    tokenFields.map((data, key) => {
      //   if (event.id === "room") {
      //     if (data.name === "roomname") {
      //       addQueue[key]["value"] = null;
      //       addQueue[key]["is_remote_valid"] = false;
      //       addQueue[key]["errors"] = [];
      //       addQueue[key]["visiable"] = true;
      //     }
      //     if (data.name === "doctorname") {
      //       addQueue[key]["value"] = null;
      //       addQueue[key]["text"] = null;
      //       addQueue[key]["is_remote_valid"] = false;
      //       addQueue[key]["errors"] = [];
      //       addQueue[key]["visiable"] = false;
      //     }
      //   }
      //   if (event.id === "doctor") {
      //     if (data.name === "doctorname") {
      //       addQueue[key]["value"] = null;
      //       addQueue[key]["text"] = null;
      //       addQueue[key]["is_remote_valid"] = false;
      //       addQueue[key]["errors"] = [];
      //       addQueue[key]["visiable"] = true;
      //     }
      //     if (data.name === "roomname") {
      //       addQueue[key]["value"] = null;
      //       addQueue[key]["is_remote_valid"] = false;
      //       addQueue[key]["errors"] = [];
      //       addQueue[key]["visiable"] = false;
      //     }
      //   }
      //   if (data.name === event.name) {
      //     if (data.is_remote_validation) {
      //       this.validateFeilds(data, event, addQueue, "addQueue");
      //     }
      //   }
    });

    this.setState({ tokenFields: tokenFields });

    // tokenFields.filter((element, key) => {
    //   if (element["name"] === event.parrentName) {
    //     console.log(element["name"]);
    //     // if (event.parrentName === 'department') {
    //     //     this.setState((state) => ({ showOperator: true }));
    //     // }

    //     if (event.parrentName === "unit") {
    //       workflow.feilds.map((data, key) => {
    //         workflow.feilds[key]["value"] = false;
    //         workflow.feilds[key]["valid"] = false;
    //       });
    //     }
    //     if (event.parrentMode === "single") {
    //       addQueue[key]["value"] = event.value;
    //       addQueue[key]["valid"] = true;
    //       addQueue.slice(key + 1).map((sele, skey) => {
    //         if (sele["relation"] && sele["relationvalue"] !== 0) {
    //           if (event.id === "service" && event.id === element["name"]) {
    //             addQueue[key + 1 + skey]["value"] = event.serviceTime;
    //             addQueue[key + 1 + skey]["valid"] = true;
    //             addQueue[key + 1 + skey]["disable"] = true;
    //           } else {
    //             addQueue[key + 1 + skey]["value"] = null;
    //             addQueue[key + 1 + skey]["valid"] = false;
    //             addQueue[key + 1 + skey]["disable"] = true;
    //           }
    //         }
    //       });
    //     }

    //     if (event.parrentMode === "group") {
    //       if (event.parrentName === "qCreateType") {
    //         console.log("qCreateType", event.value);
    //         addQueue[key]["value"] = event.value;
    //       }
    //       element["groupData"].filter((gele, gkey) => {
    //         if (gele["name"] === event.id) {
    //           console.log("came", gele);
    //           addQueue[key]["groupData"][gkey]["value"] = event.value;
    //           addQueue[key]["groupData"][gkey]["valid"] = true;
    //         }
    //         if (gele["subgroupData"]) {
    //           gele["subgroupData"].filter((gelee, ggkey) => {
    //             if (gele["name"] === event.id) {
    //               console.log("gelee", gelee);
    //               // addQueue[key]['groupData'][gkey]['subgroupData'][ggkey]['value'] = event.value;
    //               addQueue[key]["groupData"][gkey]["subgroupData"][ggkey][
    //                 "disable"
    //               ] = event.value ? false : true;
    //               addQueue[key]["groupData"][gkey]["subgroupData"][ggkey][
    //                 "valid"
    //               ] = event.value ? true : false;
    //             }
    //             if (gele["name"] === event.id && event.value === false) {
    //               console.log("enter the", event);
    //               addQueue[key]["groupData"][gkey]["subgroupData"][ggkey][
    //                 "value"
    //               ] = "null";
    //               addQueue[key]["groupData"][gkey]["subgroupData"][ggkey][
    //                 "text"
    //               ] = "null";
    //             }
    //             if (gelee["name"] === event.id) {
    //               addQueue[key]["groupData"][gkey]["subgroupData"][ggkey][
    //                 "value"
    //               ] = event.value;
    //             }
    //           });
    //         }
    //       });
    //     }
    //   }

    //   if (element["relation"] && element["relationvalue"] !== 0) {
    //     let rdvalid = [];
    //     element["relationvalue"].map((rv, rk) => {
    //       addQueue.filter((relement, rkey) => {
    //         if (relement["name"] === rv) {
    //           rdvalid.push(relement["value"] != null);
    //         }
    //       });
    //     });
    //     if (rdvalid.includes(false)) {
    //       addQueue[key]["value"] = null;
    //       addQueue[key]["valid"] = false;
    //       addQueue[key]["disable"] = true;
    //     } else {
    //       addQueue[key]["disable"] = false;
    //     }
    //   }
    // });

    // if (event.name === "unit") {
    //   let payload = {};
    //   payload["unit_id"] = event["value"];
    //   this.setState((state) => ({ add_queue_payload: payload }));
    // }
  }

  onDetails(event) {
    this.setState({
      errors: { ...this.state.errors, [event.target.name]: "" },
      [event.target.name]: event.target.value,
    });
  }

  getSearchResults(event) {
    let value = event.target.value;

    this.setState({ searchVal: value });

    let filteredList = this.state.tokensList.filter(
      (item) =>
        (item.patient_name &&
          item.patient_name.toLowerCase().includes(value.toLowerCase())) ||
        (item.phone_number && item.phone_number.includes(value))
    );
    this.setState({ filteredList });
  }
  print = () => {
    this.onRefresh();
    this.setState({ visible: false });
    window.print();
}
handleCancel = e => {

  this.onRefresh();
  this.setState({ visible: false })
}

  render() {
    const {
      tokenFields,
      tokensList,
      searchVal,
      filteredList,
      isLoading,
      errors,
      modalData
    } = this.state;

    let list = searchVal ? filteredList : tokensList;
    return (
      <div className="row q-p-details -Token-Generator">
        {isLoading && <CustomLoader />}
        {console.log("tokenFields", this.state)}
        {console.log("tokenFields errors", errors)}
        <div className="col-3 col-md-5 col-lg-3">
          <div className="card b-card">
            <span class="PatientsTitle">{`Patients (${list.length})`}</span>
            <div className="row mb-3">
              <div className="col-10">
                <Input
                  placeholder="Search here"
                  value={this.state.searchVal}
                  allowClear={true}
                  //   onSearch={this.getSearchResults.bind(this)}
                  //   onChange={(e) => {
                  //     if (e.target.value === "") {
                  //       this.getSearchResults(e.target.value);
                  //     }
                  //   }}
                  onChange={(e) => this.getSearchResults(e)}
                />
              </div>
              <div className="pl-0">
                <img
                  src={searchIcon}
                  alt=""
                  className="biller-search-icon-img operatorSearchicon"
                />
              </div>
            </div>
            <div className="b-card-scroll mb-3">
              {list &&
                list.map((listItem) => <TokenPatientCard item={listItem} />)}
            </div>
          </div>
        </div>
        <div className="col-9 col-md-7 col-lg-9">
          <div className="card b-card p-2 px-3">
            <span class="row Token-Generation">Token Generation</span>
            <div>
              {tokenFields.map((field, key) =>
                field.type === "radio" && field.mode === "group" ? (
                  <>
                    <span className="Token-Type">{field.label}</span>
                    <div className="mb-4">
                      <Radio.Group
                        name={field.name}
                        options={field.groupData.map((data) => data.label)}
                        onChange={this.onDetails.bind(this)}
                        value={
                          field.name === "tokenType"
                            ? this.state.tokenType
                            : this.state.serviceType
                        }
                      />
                      {errors && `${errors[field.name]}` && (
                        <div className="text-danger mt-1">
                          <small key={field.name}>{errors[field.name]}</small>
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  field.type === "input" &&
                  field.mode === "single" && (
                    <>
                      <span className="Enter-Phone-No">{field.label}</span>
                      <div className="mt-1">
                        <input
                          id="phone"
                          name="phone"
                          value={this.state.phone}
                          onChange={this.onDetails.bind(this)}
                          placeholder="Enter Phone Number"
                          size={40}
                          style={{ height: "37px", padding: "0 5px" }}
                        />
                      </div>
                      {errors && errors.phone && (
                        <div className="text-danger mt-1">
                          <small key={field.name}>{errors.phone}</small>
                        </div>
                      )}
                    </>
                  )
                )
              )}

              <div className="row pt-5 pl-3">
                <Button
                  className="Rectangle-Copy-10"
                  onClick={this.generateToken.bind(this)}
                >
                  <span class="Generate">Generate</span>
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="row mx-auto">
                        <Modal visible={this.state.visible} onCancel={this.handleCancel} footer={null} maskClosable={false}>
                            <div className="text-center token-popup p-5">
                                <p>Token Number</p>
                                <h1>{modalData.token_display_id}</h1>
                                {/* <h3>{modalData.phone_number}</h3> */}
                                <h2 className="text-uppercase">{modalData.phone_number}</h2>
                                <h3 className="text-capitalize">{(modalData.service && modalData.service !== null) ? modalData.service : '--'}</h3>
                                <p className="mt-2">{moment(modalData.token_datetime).format('MMMM Do YYYY, h:mm:ss a')}</p>
                                <div><button className="btn btn-success  text-capitalize mx-2 d-print-none" onClick={this.print}>print token</button>
                                    <button className="btn btn-danger  text-capitalize mx-2 d-print-none" onClick={this.handleCancel}>Close</button>
                                </div>
                            </div>
                           
                        </Modal>
                    </div>
      </div>
    );
  }
}
export default TokenGenerator;
